import { axiosInstance } from 'boot/axios.js'

export async function query(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: '/news',
      method: 'GET',
      params: queryParams
    })
    ctx.commit('items', response.data.items)
    ctx.commit('pagination', response.data.pagination)
    return response
  } catch (e) {
    throw e
  }
}

export async function get(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: parseUrl('news', queryParams),
      method: 'GET',
      params: queryParams
    })
    ctx.commit('item', response.data)
    return response
  } catch (e) {
    throw e
  }
}

function parseUrl(state, params) {
  if (state && params.id) {
    return '/' + state + '/' + params.id
  }
  return '/' + state
}
